var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon-info cl-sec-l fs-20",staticStyle:{"vertical-align":"top"}})}
var staticRenderFns = []

export { render, staticRenderFns }